






















import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import { computed, defineComponent } from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'

export default defineComponent({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin],
  setup() {
    const { getters } = useNamespacedStore<UserState>(USER_NS)

    const userHasPermission = getters('hasPermission')

    const noLeasingPermission = computed(() => {
      return !userHasPermission('classifieds.leasing')
    })

    return {
      noLeasingPermission
    }
  }
})
